// @flow

import React, { type Node, useCallback } from 'react';
import { usePayment } from '../context';
import { ErrorSvg } from '../../pix-jsr-enrollment/screens/error-screen';
import {
  Container,
  Content,
  ErrorIcon,
  Title,
  Subtitle,
  RetryButton,
} from './error-screen.styles';

const DEFAULT_ERROR_MESSAGE = 'Algo deu errado. Por favor, tente novamente.';

export function ErrorScreen(): Node {
  const { data, dispatch } = usePayment();

  const handleRetry = useCallback(() => {
    dispatch({ type: 'RETRY' });
  }, [dispatch]);

  return (
    <Container>
      <Content>
        <ErrorIcon>
          <ErrorSvg />
        </ErrorIcon>

        <Title>Ocorreu um erro</Title>
        <Subtitle>{data.errorMessage || DEFAULT_ERROR_MESSAGE}</Subtitle>

        <RetryButton onClick={handleRetry}>
          Tentar novamente
        </RetryButton>
      </Content>
    </Container>
  );
}
